import Thumb from '../thumb/thumb';
import ThumbShape from '../thumb/thumbShape';
import ThumbFont from '../thumb/thumbFont';
import ThumbGroupImage from '../thumb/thumbGroupImage';
import ThumbPlaceholder from '../thumb/thumbPlaceholder';
import ThumbSimpleText from '../thumb/thumbSimpleText';
import ThumbSvg from '../thumb/thumbSvg';
import ThumbText from '../thumb/thumbText';
import SVGPlaceholderImage from './placeholder';

export default function initThumbs () {
  window.INKIVE.SVGPlaceholderImage = SVGPlaceholderImage;
  window.INKIVE.Thumb = Thumb;
  window.INKIVE.ThumbShape = ThumbShape;
  window.INKIVE.ThumbFont = ThumbFont;
  window.INKIVE.ThumbGroupImage = ThumbGroupImage;
  window.INKIVE.ThumbPlaceholder = ThumbPlaceholder;
  window.INKIVE.ThumbSimpleText = ThumbSimpleText;
  window.INKIVE.ThumbSvg = ThumbSvg;
  window.INKIVE.ThumbText = ThumbText;
}
